import axios from 'axios'
import Endpoints from '../enums/Endpoints';
import { getErrorToast } from '../pages/ToastMessages';
import { ClearTokens, HasToken, GoToRedirectPage, GotoSSO } from '../modules/auth/components/SsoComponent';

const Login = () => {
    const token = localStorage.getItem("token");
    const tokenExpire = localStorage.getItem("tokenExpire");

    if (token !== '' && token !== null && tokenExpire !== '' && tokenExpire !== null) {
        const tokenExpireDate = new Date(tokenExpire);
        const now = new Date(Date.now());
        if (tokenExpireDate <= now) {
            ClearTokens();
            if (!HasToken())
                GotoSSO();
        }
    }
    else {
        const ssoToken = localStorage.getItem("ssotoken");
        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API_LINK}/${Endpoints.SsoAuthorization}?code=${ssoToken}`,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function (response) {
            if (response.status === 200) {
                localStorage.setItem("token", response.data.access_token);
                const expires = response.data.expires_in;
                const now = new Date(Date.now());
                now.setTime(now.getTime() + (expires * 1000))
                localStorage.setItem("tokenExpire", now.toString());
                return response.data.access_token;
            } else {
                ClearTokens();
                if (!HasToken())
                    GotoSSO();
            }
        }).catch(function () {
            ClearTokens();
            if (!HasToken())
                GotoSSO();
        });
    }
}

const SignOut = () => {
    axios({
        method: 'POST',
        url: `${process.env.REACT_APP_API_LINK}/${Endpoints.SignOut}`,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("token")
        }
    }).then(function (response) {
        if (response.status === 200) {
            const ssoToken = localStorage.getItem("ssotoken");
            const redirect_uri = window.location.origin;
            window.location.replace(`${process.env.REACT_APP_SSO_LINK}/Logout?id_token_hint=${ssoToken}&post_logout_redirect_uri=${redirect_uri}/login`);
        }
        else {
            getErrorToast("Çıkış işlemi sırasında bir hata oluştu. Anasayfaya yönlendiriliyorsunuz.");
            ClearTokens();
            GoToRedirectPage();
        }
    }).catch(function () {
        getErrorToast("Çıkış işlemi sırasında bir hata oluştu. Anasayfaya yönlendiriliyorsunuz.");
        ClearTokens();
        GoToRedirectPage();
    });
}

export { Login, SignOut }